import type { ApplicationSettingsPerStateAdminApiContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'

export const stripHtml = (html: string | null | undefined): string => (html ?? '').replace(/<[^>]*>/g, '').trim()

type SettingsSnapshot = Pick<
  ApplicationSettingsPerStateAdminApiContract,
  'DrugScreenHtml' | 'IsPhoneVisitCommunicationTypeAllowed'
>

export const hasSettingsChanged = (current: SettingsSnapshot, old: SettingsSnapshot): boolean =>
  // Both sides are now HTML (the editor stores HTML in DrugScreenHtml); compare like-for-like,
  // treating null/undefined and '' as equivalent (an absent value vs an empty editor).
  (current.DrugScreenHtml ?? '') !== (old.DrugScreenHtml ?? '') ||
  current.IsPhoneVisitCommunicationTypeAllowed !== old.IsPhoneVisitCommunicationTypeAllowed
